import { EImageModelType } from '../types/material';
import { isTalkie, isProd } from '../utils/env';
export const IMAGE_MODEL_ID_MAP: Record<EImageModelType, string> = {
  [EImageModelType.Common]: 'dcy-gen2-ft-sdxlFix-32n-20230825-s15f6-208M',
  [EImageModelType.Anime]: 'nero-gen2-ft-sdxlFix-8n-20230825-s15f6-hq240619v3-acg-gpt-1024K',
  [EImageModelType.Realistic]: isTalkie
    ? 'XL_ckpts/realityfuseXL_v30.safetensors'
    : 'XL_ckpts/TAILANG XL TurboLcm（mini）mix_V3.safetensors',
};

export const getModelType = (modelId?: string): EImageModelType | undefined => {
  if (!modelId) return undefined;
  return Object.entries(IMAGE_MODEL_ID_MAP).find(([_, value]) => value === modelId)?.[0] as
    | EImageModelType
    | undefined;
};

/** 默认画风 id */
const TEST_STYLE_ID_MAP_T: Record<EImageModelType, number> = {
  [EImageModelType.Common]: 1,
  [EImageModelType.Anime]: 10,
  [EImageModelType.Realistic]: 57,
};

const PROD_STYLE_ID_MAP_T: Record<EImageModelType, number> = {
  [EImageModelType.Common]: 1,
  [EImageModelType.Anime]: 10,
  [EImageModelType.Realistic]: 57,
};

const DEFAULT_STYLE_ID_MAP_T = isProd ? PROD_STYLE_ID_MAP_T : TEST_STYLE_ID_MAP_T;

const TEST_STYLE_ID_MAP_X: Record<EImageModelType, number> = {
  [EImageModelType.Common]: 1,
  [EImageModelType.Anime]: 51,
  [EImageModelType.Realistic]: 61,
};

const PROD_STYLE_ID_MAP_X: Record<EImageModelType, number> = {
  [EImageModelType.Common]: 1,
  [EImageModelType.Anime]: 51,
  [EImageModelType.Realistic]: 61,
};

export const DEFAULT_CFG_SCALE_MAP: Record<EImageModelType, number> = {
  [EImageModelType.Common]: 7,
  [EImageModelType.Anime]: 7,
  [EImageModelType.Realistic]: 2.5,
};

export const CFG_SCALE_STEPS_MAP: Record<
  EImageModelType,
  { low: number; mid: number; high: number }
> = {
  [EImageModelType.Common]: {
    low: 6,
    mid: 7,
    high: 8,
  },
  [EImageModelType.Anime]: {
    low: 6,
    mid: 7,
    high: 8,
  },
  [EImageModelType.Realistic]: {
    low: 1.5,
    mid: 2.5,
    high: 3.5,
  },
};

export const getCfgScaleLevel = (modelType: EImageModelType, cfgScale: number) => {
  const steps = CFG_SCALE_STEPS_MAP[modelType];
  const { low, mid, high } = steps;

  if (cfgScale <= low) return 'low';
  if (cfgScale <= mid) return 'mid';
  if (cfgScale <= high) return 'high';
  return 'high';
};

export const DEFAULT_STYLE_WEIGHT = 0.8;
export const DEFAULT_FACE_WEIGHT = 0.8;

const DEFAULT_STYLE_ID_MAP_X = isProd ? PROD_STYLE_ID_MAP_X : TEST_STYLE_ID_MAP_X;

export const DEFAULT_STYLE_ID_MAP = isTalkie ? DEFAULT_STYLE_ID_MAP_T : DEFAULT_STYLE_ID_MAP_X;

export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
